<template>

  <Header
    label="Tickets für"
    :headline="event.name"
  />

  <section class="bg-gray-300 py-20">
    <div class="container">
      <EventPresale
        :event="event"
        :methods="methods"
      />
    </div>
  </section>

</template>

<script>
import useMeta from '@/compose/meta';
import Layout from 'Web/Layouts/WithCart.vue';
import EventPresale from 'Web/Shared/EventPresale.vue';
import Header from 'Web/Shared/Header.vue';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    EventPresale,
    Header,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    methods: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { assign } = useMeta();

    assign({ title: `DAS DA-Onlineshop - ${props.event.name}` });

  }
}
</script>
